// This file is generated by scripts/generate-string-constants.js.
// Do not edit this file directly.

export default [
	'var',
	'let',
	'const',
	'init',
	'get',
	'set',
	'constructor',
	'method',
	'-',
	'+',
	'!',
	'~',
	'typeof',
	'void',
	'delete',
	'++',
	'--',
	'==',
	'!=',
	'===',
	'!==',
	'<',
	'<=',
	'>',
	'>=',
	'<<',
	'>>',
	'>>>',
	'+',
	'-',
	'*',
	'/',
	'%',
	'|',
	'^',
	'&',
	'||',
	'&&',
	'in',
	'instanceof',
	'**',
	'??',
	'=',
	'+=',
	'-=',
	'*=',
	'/=',
	'%=',
	'<<=',
	'>>=',
	'>>>=',
	'|=',
	'^=',
	'&=',
	'**=',
	'&&=',
	'||=',
	'??=',
	'pure',
	'noSideEffects',
	'sourcemap',
	'using',
	'await using'
];
